<template>
  <div>
    <el-form ref="formRef" :model="priceForm" label-width="180px">
      <el-form-item label="金币数量：">
        <el-input v-model="priceForm.num" placeholder="请输入金币数量" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="打折前的价格：">
        <el-input v-model="priceForm.oldPrice" placeholder="请输入打折前价格" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="打折后的价格：">
        <el-input v-model="priceForm.newPrice" placeholder="请输入打折后价格" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="折扣：">
        <el-input v-model="priceForm.discount" placeholder="正整数，请输入折扣" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="priceForm.orderNum" placeholder="数字越大越靠前" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="state" placeholder="Select" style="width: 10em">
          <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台：">
        <el-select v-model="type" placeholder="Select" style="width: 10em" @change="typeChange">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道：">
        <el-input v-model="priceForm.channel" placeholder="请输入渠道" style="width:25em;" :disabled="type == 1 || type == 4"/>
      </el-form-item>
      <el-form-item label="productId：" v-show="type == 2">
        <el-input v-model="priceForm.productId" placeholder="请输入productId" style="width:25em;"/>
      </el-form-item>
      <el-form-item label="金币展示：">
        <el-select v-model="showType" placeholder="Select" style="width: 10em">
          <el-option v-for="item in showTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
      <div class="dialog-footer" style="text-align: center">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { saveOrUpdateGoldPrice } from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      priceForm: this.value.priceForm,
      idx: this.value.ids,
      state: this.value.ids > -1? this.value.priceForm.state: 0,
      stateArray: [
        {label:'生效', value:0},
        {label:'下架', value:1},
      ],

      typeArray: [
        {label:'Android', value:1},
        {label:'鸿蒙', value:4},
        {label:'IOS', value:2},
      ],
      type: this.value.priceForm.platformType?this.value.priceForm.platformType:1,

      // 金币展示
      showTypeArray: [
        {label: '全部展示', value: -1},
        {label: '仅购买页面展示', value: 1},
        {label: '仅弹框展示', value: 2}
      ],
      showType: this.value.ids > -1? this.value.priceForm.showType:-1,
    }
  },
  methods: {

    typeChange() {
      if(this.type == 1 || this.type == 4) {
        this.priceForm.channel = 'app'
      }else {
        this.priceForm.channel = ''
        this.priceForm.productId = ''
      }
    },

    cancel() {
      this.$emit("close");
    },
    submit() {
      if(!this.priceForm.num) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '金币数量不能为空',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.priceForm.num)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请正确输入金币数量',
          type: 'warning'
        });
        return false
      }
      if(!this.priceForm.newPrice) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入打折后价格',
          type: 'warning'
        });
        return false
      }
      if(!this.priceForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.priceForm.orderNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请正确输入排序号码',
          type: 'warning'
        });
        return false
      }
      if(this.type == 2 && !this.priceForm.channel) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入渠道',
          type: 'warning'
        });
        return false
      }
      if(this.type == 2 && !this.priceForm.productId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入productId',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.idx == -1?0: this.priceForm.id;
      param['channel'] = this.priceForm.channel;
      param['productId'] = this.priceForm.productId;
      param['num'] = this.priceForm.num;
      param['oldPrice'] = this.priceForm.oldPrice?this.priceForm.oldPrice:0;
      param['newPrice'] = this.priceForm.newPrice;
      param['discount'] = this.priceForm.discount;
      param['state'] = this.state;
      param['orderNum'] = this.priceForm.orderNum;
      param['showType'] = this.showType;
      param['platformType'] = this.type;
      postFormData(saveOrUpdateGoldPrice, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }
  },
  mounted() {
    // if(this.priceForm.channel && this.priceForm.channel != 'app') {
    //   this.type = 2
    // }else {
    //   this.type = 1
    //   this.priceForm.channel = 'app'
    // }
    if(this.idx == -1) {
      this.priceForm.channel = 'app'
    }
  }
}
</script>

<style scoped>

</style>
